import './_styles.scss';
import React from "react";
import Review from './_review';

export default (props) => {

  if (!props.release) return null;

  return (
    <div className='Product-Reviews'>
      <div className="Section-Wrapper">

        <div className="Section-Heading">Top Customer Reviews</div>

        <Review/>

        <button className="Add-Review-Button">
          Write a customer review
        </button>

      </div>
    </div>
  );

}
